<app-modal-header [title]="title" (closeModal)="closeModal()"></app-modal-header>

<main-dynamic-form
  (submit)="submitForm($event)"
  [fields]="fields"
  [form]="form"
  [loading]="loading"
  [showRequiredTitle]="false"
  loadingMessage="Operation in progress, please wait..."
  [confirmFirst]="true"
  confirmMessage="You are about to save your data. Do you want to continue?"

></main-dynamic-form>

